import {
  IGCCClientTax,
  TaxType,
  TicketItemEGPTax,
} from "adminPanel/settings/settingTaxes/ITaxSystem";
import { IUnitsGroup } from "adminPanel/settings/units/IUnitsGroup";
import { IExternalOperation } from "amnPos/shiftsAndExternals/externalOperations/ExternalOperationData";
import { ItemBehavior } from "amnRestaurants/ticket/RestTicket";
import { IDeliveryOrderInfo } from "amnShared/interfaces/IDeliveryOrderInfo";
import { IPickUpOrderInfo } from "amnShared/interfaces/IPickUpOrderInfo";
import { ITableOrderInfo } from "amnRestaurants/ticket/RestTicket";
import { store } from "app/store";
import {
  TransactionTypes,
  TicketStatus,
  OrderType,
} from "models/common-props/TransactionTypes";
import { TicketPaymentGetway } from "models/PaymentModel";

import { NIL } from "uuid";
import {
  IClient,
  IMenusOptions,
  IOrder,
  IPreaparingAndServing,
  IReportsOptions,
  IShift,
  ITransactionPermissions,
  ITransactions,
} from "adminPanel/employee/models/IEmployee";
import { EGPSubmissionState } from "helpers/egpTaxesReceiptsHelper";

export enum ApprovalType {
  NONE,
  SupervisorItemDiscount,
  SupervisorAllItemDiscount,
  SupervisorPayToClient,
  SupervisorReciveFromClient,
  SupervisorPayToCenteralBox,
  SupervisorReciveFromCenteralBox,
  SupervisorDeleteExternalTransaction,
  SupervisorMaxAllowedTransaction,
  SupervisorChangeItemPrice,
  SupervisorSellWithDept,
  SupervisorRemoveItem,
  SupervisorDecreaseItemQuantity,
  SupervisorShowSettledTransaction,
  SupervisorRepeatPrintingSettledTransaction,
  SupervisorManuallyOpenDrawer,
  SupervisorUseForignCurrencies,
  SupervisorChangeExchgangeRate,
  SupervisorCloseShift,
  SupervisorViewCalculatedCash,
  SupervisorPrintShiftSummary,
  SupervisorPostCashToNextShift,
  SupervisorUnCloseShift,
  SupervisorViewCustomerBalanceStatement,
  SupervisorShowCustomerBalance,
  SupervisorViewCalculatedCashDetails,
  SupervisorViewCalculatedNonCashDetails,
  SupervisorViewShiftDigest,
  SupervisorViewMaterialsAndServicesTransactionsDetail,
  SupervisorViewExternalTransactionsDetails,
  SupervisorViewClosingDetails,
  SupervisorChangeCentralBoxReceiptNumberMandatory,
  // Order
  SupervisorAddPickUpOrder,
  SupervisorAddDeliveryOrder,
  SupervisorEditDeliveryFees,
  SupervisorReceivePrepayment,
  SupervisorCancelOrder,
  SupervisorEditSavedOrder,
  SupervisorUseOrderManagementTab,
  SupervisorUseDeliveryOrdersManagement,
  SupervisorSettlePickupOrder,
  SupervisorSettleDeliveryTrip,
  SupervisorSettleTableOrder,
  SupervisorMoveOrder,
  SupervisorMoveOrderItems,
  // Client
  SupervisorAddNewClient,
  SupervisorModifyExistingClient,
  SupervisorChangeDefaultCountryAndProvince,
  SupervisorAddNewAddress,
  SupervisorModifyAddress,
  // Menus
  SupervisorChangeMenu,
  SupervisorUseMenuOutsideOperatingHours,
  SupervisorChangeMenuWhenOpenOrder,
  // PreparingAndServing
  SupervisorCancelOrderAfterPreparationStarts,
  SupervisorCancelOrderAfterServed,
  SupervisorCancelItemAfterPreparationStarts,
  SupervisorCancelItemAfterServed,
  SupervisorChangeItemQuantityAfterPreparationStarts,
  SupervisorChangeItemQuantityAfterServed,
  SupervisorReturnOrderFromInPreparation,
  SupervisorEndPreparationInKitchenWindow,
  SupervisorHandleTableOrder,
  SupervisorPrintCustomizationBeforeCollect,
  SupervisorSendEReceipt,
}

export enum ApprovalSource {
  None = 0,
  MaterialsOperations,
  ExternalOperations,
  Commands,
}

export enum ApprovalSourceType {
  None,
  Sales,
  FastService,
  FullService,
  DeliveryOrder,
  PickupOrder,
  PayToClient,
  ReceiveFromClient,
  PayToCenteralCash,
  ReceiveFromCenteralCash,
  DeleteExternalTransaction,
  MaxAllowedTransaction,
  ShowSettledTransaction,
  RepeatPrintingSettledTransaction,
  ManuallyOpenDrawer,
  CloseShift,
  ViewCalculatedCash,
  PrintShiftSummary,
  PostCashToNextShift,
  UnCloseShift,
  ViewCustomerBalanceStatement,
  ShowCustomerBalance,
  ViewCalculatedCashDetails,
  ViewCalculatedNonCashDetails,
  ViewShiftDigest,
  ViewMaterialsAndServicesTransactionsDetail,
  ViewExternalTransactionsDetails,
  ViewClosingDetails,
  UseOrderManagementTab,
  UseDeliveryOrdersManagement,
  AddNewClient,
  ModifyExistingClient,
  ChangeDefaultCountryAndProvince,
  AddNewAddress,
  ModifyAddress,
  ChangeMenu,
  UseMenuOutsideOperatingHours,
  ChangeMenuWhenOpenOrder,
  CancelOrderAfterPreparationStarts,
  CancelOrderAfterServed,
  CancelItemAfterPreparationStarts,
  CancelItemAfterServed,
  ChangeItemQuantityAfterPreparationStarts,
  ChangeItemQuantityAfterServed,
  ReturnOrderFromInPreparation,
  EndPreparationInKitchenWindow,
  ChangeCentralBoxReceiptNumberMandatory,
  EditDeliveryFees,
  ReceivePrepayment,
  SettleDeliveryTrip,
  MoveOrder,
  MoveOrderItems,
  ChangeExchnageRate,
  UseForignCurrencies,
  EditSavedOrder,
  CancelOrder,
  SettleTableOrder,
  SettlePickupOrder,
  PrintCustomizationBeforeCollect,
  SendEReceipt,
}
export interface ISupervisor {
  id: string;
  supervisor: string;
  supervisorMaxDiscountForItem: number;
  supervisorMaxDiscountForAllItems: number;
  supervisorTransactionsOptions: ITransactions;
  supervisorTransactionsPermissionOptions: ITransactionPermissions;
  supervisorShiftOptions: IShift;
  supervisorReportsOptions: IReportsOptions;
  supervisorOrderOptions: IOrder;
  supervisorClientOptions: IClient;
  supervisorMenusOptions: IMenusOptions;
  supervisorPreparingAndServing: IPreaparingAndServing;
}
export interface IAllowedApproval {
  id: string;
  type: ApprovalType;
  item: IItemApproval;
  supervisorAllowedApprovalId: string;
  employeeRequestedApprovalId: string;
  discountPercentageAllowed: number;
  maxTransactionValueAllowed: number;
  approvalExpireAt: Date;
}

export interface IItemApproval {
  id: string;
  discountPercentageAllowed?: number;
  valueAllowed?: number;
}

export interface IRequestedApproval {
  supervisorId: string;
  employeeId: string;
  currencyId?: string;
  clientId?: string;
  pin: string;
  items?: IItemApproval[];
  type: ApprovalType;
  discountPercentageAllowed?: number;
  valueAllowed?: number;
  ticketIds?: string[];
  posId?: string;
  shiftId?: string;
  source: ApprovalSource;
  sourceType: ApprovalSourceType;
}
export default interface Ticket {
  id: string;
  number: number;
  code: string;
  note: string;
  total: number;
  totalPaid: number;
  taxTotal: number;
  type: TransactionTypes;
  orderType: OrderType;
  isDiscountPercentage: boolean;
  discountValue: number;
  status: TicketStatus;
  additionTime: Date | string;
  shiftId?: string;
  shiftCode: string;
  posId: string;
  employeeId: string;
  employee: string;
  employeeCode: string;
  salesmanId: string | null;
  salesman: string | null;
  clientId: string | null;
  client: string | null;
  store?: string;
  clientLastModified: string;
  ticketPaymentGetways: TicketPaymentGetway[];
  ticketItems: TicketItem[];
  deliveryOrderInfo?: IDeliveryOrderInfo | null;
  pickupOrderInfo?: IPickUpOrderInfo | null;
  tableOrderInfo?: ITableOrderInfo | null;
  externalOperations?: IExternalOperation[];
  gccTax?: IGCCClientTax;
  prevTotalPaid?: number;
  cancelledTime?: Date;
  pos?: string;
  settlementTime?: Date;
  clientPhone?: string;
  allowedApprovals?: IAllowedApproval[];
  localAdministrationFee?: TicketSYRLocalAdministrationFee | null;
  ticketSYRRestaurantTaxes?: TicketSYRRestaurantTax[];
  consumptionFeeRoundUpTo?: number | null;
  egpSubmissionState?: EGPSubmissionState;
  isTicketBeforeEnableTaxesSubscriptionDate: boolean;
}

export interface TicketItem {
  id: string;
  number: number;
  ticketId: string;
  itemId: string;
  item: string | null;
  image?: string;
  price: number;
  totalUnitPrice: number;
  qty: number;
  discountPercent: number;
  discountValue: number;
  giftQty: number;
  value: number;
  total: number;
  net: number;
  unit: string | null;
  unitId: string;
  salesmanId: string | null;
  salesman: string | null;
  isReseted: boolean;
  isDisabled?: boolean;
  barcode?: string;
  giftsValue: number;
  giftsPercent: number;
  itemBehavior?: ItemBehavior;
  unitsGroup?: IUnitsGroup;
  taxValue: number;
  taxRatio: number;
  description?: string;
  note?: string;
  taxType?: TaxType;
  ticketItemEGPTaxesDetails: TicketItemEGPTax[];
  consumerTaxPercentage?: number | null;
}

export const emptyTicketItem: TicketItem = {
  id: NIL,
  number: 0,
  ticketId: NIL,
  itemId: NIL,
  item: "",
  image: "",
  price: 0,
  totalUnitPrice: 0,
  qty: 0,
  discountPercent: 0,
  discountValue: 0,
  giftQty: 0,
  value: 0,
  total: 0,
  net: 0,
  taxValue: 0,
  unit: "",
  unitId: NIL,
  salesmanId: NIL,
  salesman: "",
  isReseted: false,
  barcode: "",
  giftsValue: 0,
  giftsPercent: 0,
  itemBehavior: ItemBehavior.Inventory,
  isDisabled: false,
  taxRatio: 0,
  description: "",
  note: "",
  ticketItemEGPTaxesDetails: [],
  consumerTaxPercentage: null,
};

export interface TicketSYRLocalAdministrationFee {
  feePercentage?: number | null;
  roundUpTo?: number | null;
  value?: number | null;
}

export interface TicketSYRRestaurantTax {
  id: string;
  ticketId: string;
  syrRestaurantTaxId: string;
  taxName: string;
  taxPercentage: number;
  roundUpTo: number;
  taxValue?: number | null;
}

export enum DiscountType {
  Item,
  AllItems,
}

export interface ItemDiscount {
  discType: DiscountType;
  discPercent?: number;
  discValue?: number;
}

export const ticketDto = (ticket: Ticket) => {
  return {
    ...ticket,
    salesman: null,
    salesmanId: null,
    client: null,
    employeeId: store.getState().employeeSettings.id,
    shiftId: store.getState().shiftInfo.id,
    shift: null,
    ticketItems: ticket.ticketItems.map((item, index) => {
      return {
        ...item,
        number: index,
        ticketId: ticket.id,
        salesman: null,
        salesmanId: null,
        unit: null,
        item: null,
      };
    }),
  } as Ticket;
};

export interface ITicketItemsTotals {
  itemDiscount: number;
  vat: number;
  total: number;
  totalDownPayment: number;
  totalTicketPayment: number;
}

export const emptyTicketItemsTotals: ITicketItemsTotals = {
  itemDiscount: 0,
  vat: 0,
  total: 0,
  totalDownPayment: 0,
  totalTicketPayment: 0,
};

export interface ITicketPaymentsTotals {
  transactionValue: number;
  collected: number;
  deferredAmount: number;
}

export const emptyTicketPaymentsTotals: ITicketPaymentsTotals = {
  transactionValue: 0,
  collected: 0,
  deferredAmount: 0,
};

export const emptyTicket: Ticket = {
  id: NIL,
  number: 0,
  code: "",
  note: "",
  total: 0,
  totalPaid: 0,
  taxTotal: 0,
  orderType: OrderType.none,
  type: TransactionTypes.sales,
  isDiscountPercentage: false,
  discountValue: 0,
  status: TicketStatus.new,
  additionTime: "",
  shiftCode: "",
  posId: "",
  shiftId: "",
  employeeId: NIL,
  employee: "",
  employeeCode: "",
  salesmanId: null,
  salesman: null,
  clientId: null,
  client: null,
  ticketPaymentGetways: [],
  ticketItems: [],
  deliveryOrderInfo: null,
  pickupOrderInfo: null,
  clientLastModified: "",
  pos: "",
  settlementTime: undefined,
  clientPhone: "",
  allowedApprovals: [],
  localAdministrationFee: null,
  ticketSYRRestaurantTaxes: [],
  consumptionFeeRoundUpTo: null,
  egpSubmissionState: 0,
  isTicketBeforeEnableTaxesSubscriptionDate: true,
};

export type CustomizedTicketDocuments = { [key: string]: string };
